<div class="bc-wrapper">
  <form [formGroup]="branchContactDetailForm">

    <div class="bc-section-inner">
    <div class="bc-subsection-header">
      <span class="bc-subsection-title">Business Segment Wise Branch Contact Details</span>
      <div class="bc-alert-counts" *ngIf="!disableTable">
        <span class="bc-badge bc-wa-badge" matTooltip="WhatsApp alerts selected">
          <mat-icon>whatsapp</mat-icon> {{waAlertCount}}
        </span>
        <span class="bc-badge bc-email-badge" matTooltip="Email alerts selected">
          <mat-icon>email</mat-icon> {{emailAlertCount}}
        </span>
      </div>
      <div class="bc-header-actions">
        <button mat-icon-button type="button" (click)="addRow()"
                *ngIf="!disableTable" matTooltip="Add Row" class="bc-add-btn">
          <mat-icon>add</mat-icon>
        </button>
        <button mat-icon-button type="button" (click)="onCancel()"
                *ngIf="isOpenedAsDialog" matTooltip="Close" class="bc-close-btn">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <div class="bc-table-wrapper">
    <table mat-table [dataSource]="branchContactDataSource" formArrayName="contactDetailsDto"
           class="bc-table" [ngClass]="{'row-disabled': disableTable && !isDialogMode}">

      <!-- Business Segment -->
      <ng-container matColumnDef="businessSegment">
        <th mat-header-cell *matHeaderCellDef>Business Segment</th>
        <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
          <ng-container *ngIf="disableTable && !isDialogMode; else editSegment">
            {{ getSegmentName(i) }}
          </ng-container>
          <ng-template #editSegment>
            <mat-form-field appearance="fill" class="bc-field bc-segment-field">
              <mat-select formControlName="businessSegmentId" placeholder="Select"
                          panelClass="bc-segment-panel"
                          (selectionChange)="onSegmentChange(i)">
                <mat-option *ngFor="let seg of businessSegments" [value]="seg.businessSegmentId">
                  {{seg.businessSegmentName}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="contactDetailsDto.at(i).get('businessSegmentId')?.hasError('required')">
                Business Segment is required
              </mat-error>
            </mat-form-field>
          </ng-template>
        </td>
      </ng-container>

      <!-- Contact Name -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Contact Name</th>
        <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
          <mat-form-field appearance="fill" class="bc-field bc-name-field">
            <input matInput formControlName="name" placeholder="Contact Name" autocomplete="off" maxlength="100"
                   [matTooltip]="contactDetailsDto.at(i).get('name')?.value"
                   (blur)="trimControl(contactDetailsDto.at(i).get('name'))">
            <mat-error *ngIf="contactDetailsDto.at(i).get('name')?.touched && contactDetailsDto.at(i).get('name')?.hasError('maxlength')">
              Max 100 characters allowed
            </mat-error>
            <mat-error *ngIf="contactDetailsDto.at(i).get('name')?.touched && contactDetailsDto.at(i).get('name')?.hasError('pattern')">
               Only alphabets are allowed.
            </mat-error>
          </mat-form-field>
        </td>
      </ng-container>

      <!-- Designation -->
      <ng-container matColumnDef="designation">
        <th mat-header-cell *matHeaderCellDef>Designation</th>
        <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
          <mat-form-field appearance="fill" class="bc-field bc-designation-field">
            <input matInput formControlName="designationName" placeholder="Designation" autocomplete="off"
                   (blur)="trimControl(contactDetailsDto.at(i).get('designationName'))">
          </mat-form-field>
        </td>
      </ng-container>

      <!-- Email Id -->
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>Email Id</th>
        <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
          <mat-form-field appearance="fill" class="bc-field bc-email-field">
            <input matInput formControlName="email" placeholder="Email Id" autocomplete="off" maxlength="100"
                   [matTooltip]="contactDetailsDto.at(i).get('email')?.value"
                   (blur)="trimControl(contactDetailsDto.at(i).get('email'))">
            <mat-error *ngIf="contactDetailsDto.at(i).get('email')?.touched && contactDetailsDto.at(i).get('email')?.hasError('maxlength')">
              Max 100 characters allowed
            </mat-error>
            <mat-error *ngIf="contactDetailsDto.at(i).get('email')?.touched && contactDetailsDto.at(i).get('email')?.hasError('pattern') && !contactDetailsDto.at(i).get('email')?.hasError('maxlength')">
              Enter a valid email address
            </mat-error>
          </mat-form-field>
        </td>
      </ng-container>

      <!-- Mobile Number -->
      <ng-container matColumnDef="cellNumber">
        <th mat-header-cell *matHeaderCellDef>Mobile Number</th>
        <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
          <div class="bc-mobile-cell">

            <!-- Dial Code Search Autocomplete -->
            <mat-form-field appearance="fill" class="bc-dial-code-field">
              <input matInput
                     placeholder="Code"
                     [formControl]="rowMobileState[i]?.dialCodeSearchCtrl"
                     [matAutocomplete]="dialAuto"
                     autocomplete="off"
                     [disabled]="disableTable && !isDialogMode"
                     [matTooltip]="getDialCodeTooltip(i)"
                     matTooltipShowDelay="300">
              <mat-autocomplete #dialAuto="matAutocomplete" [panelWidth]="260"
                                (optionSelected)="onRowCountrySelected(i, $event.option.value)">
                <mat-option *ngFor="let item of rowMobileState[i]?.filteredDialCodes" [value]="item.dialCode">
                  {{ item.countryName }} ({{ item.dialCode }})
                </mat-option>
              </mat-autocomplete>
              <button mat-icon-button matSuffix type="button"
                      *ngIf="rowMobileState[i]?.dialCodeSearchCtrl?.value && !disableTable"
                      (click)="clearRowDialCode(i)" class="bc-clear-btn">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>

            <!-- Number Plain Input -->
            <mat-form-field appearance="fill" class="bc-number-field">
              <input [id]="'phoneInput_' + i"
                     matInput
                     [formControl]="rowMobileState[i]?.phoneNumberCtrl"
                     (keydown)="onPhoneKeyDown(i, $event)"
                     (input)="onPhoneInput(i, $event)"
                     placeholder="Mobile Number"
                     autocomplete="off"
                     [disabled]="disableTable && !isDialogMode">
            </mat-form-field>

          </div>
        </td>
      </ng-container>

      <!-- WhatsApp Alert -->
      <ng-container matColumnDef="isWaAlert">
        <th mat-header-cell *matHeaderCellDef class="bc-check-header">
          <mat-icon class="bc-icon-wa">whatsapp</mat-icon>
        </th>
        <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i" class="bc-check-cell">
          <ng-container *ngIf="disableTable && !isDialogMode; else editWa">
            <mat-icon *ngIf="contactDetailsDto.at(i).get('isWaAlert')?.value" class="bc-icon-wa bc-icon-sm">check_circle</mat-icon>
          </ng-container>
          <ng-template #editWa>
            <mat-checkbox formControlName="isWaAlert" color="primary"></mat-checkbox>
          </ng-template>
        </td>
      </ng-container>

      <!-- Email Alert -->
      <ng-container matColumnDef="isEmailAlert">
        <th mat-header-cell *matHeaderCellDef class="bc-check-header">
          <mat-icon class="bc-icon-email">email</mat-icon>
        </th>
        <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i" class="bc-check-cell">
          <ng-container *ngIf="disableTable && !isDialogMode; else editEmail">
            <mat-icon *ngIf="contactDetailsDto.at(i).get('isEmailAlert')?.value" class="bc-icon-email bc-icon-sm">check_circle</mat-icon>
          </ng-container>
          <ng-template #editEmail>
            <mat-checkbox formControlName="isEmailAlert" color="primary"></mat-checkbox>
          </ng-template>
        </td>
      </ng-container>

      <!-- Decision Maker (mandatory) -->
      <ng-container matColumnDef="decisionMaker">
        <th mat-header-cell *matHeaderCellDef>Decision Maker</th>
        <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
          <div class="bc-toggle-cell">
            <mat-slide-toggle formControlName="decisionMaker" [disabled]="disableTable && !isDialogMode"></mat-slide-toggle>
          </div>
        </td>
      </ng-container>

      <!-- Gatekeeper -->
      <ng-container matColumnDef="gatekeeper">
        <th mat-header-cell *matHeaderCellDef>Gatekeeper</th>
        <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
          <mat-slide-toggle formControlName="gatekeeper" [disabled]="disableTable && !isDialogMode"></mat-slide-toggle>
        </td>
      </ng-container>

      <!-- Coach -->
      <ng-container matColumnDef="coach">
        <th mat-header-cell *matHeaderCellDef>Coach</th>
        <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
          <mat-slide-toggle formControlName="coach" [disabled]="disableTable && !isDialogMode"></mat-slide-toggle>
        </td>
      </ng-container>

      <!-- Veto -->
      <ng-container matColumnDef="veto">
        <th mat-header-cell *matHeaderCellDef>Veto</th>
        <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
          <mat-slide-toggle formControlName="veto" [disabled]="disableTable && !isDialogMode"></mat-slide-toggle>
        </td>
      </ng-container>

      <!-- Left the Organization -->
      <ng-container matColumnDef="leftOrganization">
        <th mat-header-cell *matHeaderCellDef>Left the Organization</th>
        <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
          <mat-slide-toggle formControlName="leftOrganization" [disabled]="disableTable && !isDialogMode"></mat-slide-toggle>
        </td>
      </ng-container>

      <!-- Action -->
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
          <span class="__action_delete_icon" (click)="deleteRow(i)"
                *ngIf="!disableTable" matTooltip="Delete">
            <mat-icon>delete</mat-icon>
          </span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    </div>
    </div>

  </form>

  <div class="bc-actions mat-card-actions" *ngIf="!buttonHidden">
    <button mat-button color="primary" (click)="onSave()" *ngIf="branchContactDetailForm?.dirty">SAVE</button>
    <button mat-button color="cancel" (click)="onCancel()">CANCEL</button>
  </div>
</div>
